export default __webpack_public_path__ + "static/media/twitter.6526b471.svg";